// Termini e Condizioni del servizio — BOZZA da revisione legale prima del go-live.
import LegalLayout from "@/components/LegalLayout";
import { Seo } from "@/components/public/Seo";
import publicContent from "@/pages/public/publicContent.json";

const TERMINI_SEO = publicContent.routes.find((r) => r.path === "/termini");

export default function Termini() {
  return (
    <LegalLayout title="Termini e Condizioni di Servizio" updatedAt="giugno 2026"
      testId="termini-page">
      <Seo title={TERMINI_SEO.title} description={TERMINI_SEO.description} path="/termini" />
      <section>
        <h2 className="text-lg font-bold text-slate-900">1. Oggetto</h2>
        <p>I presenti Termini regolano l'uso della piattaforma SaaS "ESG-PMI"
        per la raccolta, l'organizzazione e la rendicontazione dei dati ESG secondo
        lo standard VSME e i framework collegati (MEF PMI-Banche). Il servizio è
        fornito da [DENOMINAZIONE FORNITORE], [INDIRIZZO], P.IVA [DA COMPILARE].</p>
      </section>
      <section>
        <h2 className="text-lg font-bold text-slate-900">2. Account e ruoli</h2>
        <p>L'accesso è personale e riservato. L'amministratore aziendale è responsabile
        della gestione degli utenti e dei ruoli assegnati. Per i ruoli ad alto privilegio
        può essere richiesta la verifica in due passaggi (MFA). Le credenziali non
        devono essere condivise.</p>
      </section>
      <section>
        <h2 className="text-lg font-bold text-slate-900">3. Responsabilità sui dati</h2>
        <p>Il cliente è titolare e responsabile dell'accuratezza, completezza e liceità
        dei dati inseriti e dei documenti caricati. La piattaforma fornisce strumenti
        di calcolo e rendicontazione: le informazioni generate non costituiscono
        consulenza legale, fiscale o di sostenibilità. La revisione finale dei report
        resta a carico del cliente e/o del suo consulente.</p>
      </section>
      <section>
        <h2 className="text-lg font-bold text-slate-900">4. Assistente AI (Eva)</h2>
        <p>Le risposte dell'assistente AI sono generate automaticamente a partire dai
        dati autorizzati e da contenuti normativi di riferimento: possono contenere
        errori e devono essere verificate prima di qualsiasi uso decisionale o esterno.
        Le azioni ad alto impatto richiedono conferma umana esplicita.</p>
      </section>
      <section>
        <h2 className="text-lg font-bold text-slate-900">5. Data Room e condivisioni</h2>
        <p>La condivisione tramite Data Room avviene su esclusiva iniziativa del cliente,
        che è responsabile della selezione dei contenuti e dei destinatari. I link di
        accesso sono monouso, scadono automaticamente e sono revocabili in qualsiasi
        momento; gli accessi sono tracciati in audit.</p>
      </section>
      <section>
        <h2 className="text-lg font-bold text-slate-900">6. Disponibilità e livelli di servizio</h2>
        <p>Il servizio è fornito con impegno di disponibilità [SLA — DA DEFINIRE, es. 99,5%
        mensile]. Sono escluse interruzioni per manutenzione programmata notificata e
        cause di forza maggiore. [DEFINIRE PENALI/CREDITI CON IL LEGALE]</p>
      </section>
      <section>
        <h2 className="text-lg font-bold text-slate-900">7. Limitazione di responsabilità</h2>
        <p>Nei limiti consentiti dalla legge, il fornitore non risponde di danni
        indiretti, perdita di profitto o decisioni assunte sulla base dei contenuti
        generati. La responsabilità complessiva è limitata a [IMPORTO/CANONE — DA DEFINIRE].</p>
      </section>
      <section>
        <h2 className="text-lg font-bold text-slate-900">8. Recesso e cancellazione dati</h2>
        <p>Il cliente può recedere in qualsiasi momento con preavviso di [DA DEFINIRE].
        Alla cessazione, i dati restano esportabili per [PERIODO — DA DEFINIRE], dopodiché
        sono cancellati secondo l'Informativa Privacy.</p>
      </section>
      <section>
        <h2 className="text-lg font-bold text-slate-900">9. Legge applicabile e foro</h2>
        <p>I presenti Termini sono regolati dalla legge italiana. Foro competente:
        [DA DEFINIRE]. Per i clienti consumatori restano ferme le tutele inderogabili
        del Codice del Consumo.</p>
      </section>
    </LegalLayout>
  );
}
